var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "voucher-list"
  }, [_c('div', {
    staticClass: "bg-white"
  }, [_c('div', {
    staticClass: "p-6 shadow-border-b"
  }, [_c('h1', {
    staticClass: "text-2xl font-bold text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('voucher.title')))]), _c('p', {
    staticClass: "text-sm text-neutral-500 mt-2"
  }, [_vm._v(_vm._s(_vm.$t('voucher.subtitle')))])]), _c('div', {
    staticClass: "p-6 border-b border-gray-200"
  }, [_c('div', {
    staticClass: "max-w-md"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-gray-700 mb-2",
    attrs: {
      "for": "search"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('voucher.searchLabel')) + " ")]), _c('div', {
    staticClass: "relative"
  }, [_c('div', {
    staticClass: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
  }, [_c('svg', {
    staticClass: "h-5 w-5 text-gray-400",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
    }
  })])]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchQuery,
      expression: "searchQuery"
    }],
    staticClass: "block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-lg focus:ring-primary-500 focus:border-primary-500 text-sm",
    attrs: {
      "id": "search",
      "type": "text",
      "placeholder": _vm.$t('voucher.searchPlaceholder')
    },
    domProps: {
      "value": _vm.searchQuery
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value;
      }, _vm.handleSearch]
    }
  }), _vm.searchQuery ? _c('div', {
    staticClass: "absolute inset-y-0 right-0 pr-3 flex items-center"
  }, [_c('button', {
    staticClass: "text-gray-400 hover:text-gray-600 transition-colors",
    on: {
      "click": _vm.clearSearch
    }
  }, [_c('svg', {
    staticClass: "h-5 w-5",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M6 18L18 6M6 6l12 12"
    }
  })])])]) : _vm._e()])])]), _c('div', {
    staticClass: "p-6"
  }, [_vm.loading ? _c('div', {
    staticClass: "flex justify-center items-center py-20"
  }, [_c('div', {
    staticClass: "animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500"
  })]) : _vm.voucherList.items.length === 0 ? _c('div', {
    staticClass: "text-center py-20"
  }, [_c('svg', {
    staticClass: "h-24 w-24 mx-auto mb-4 text-gray-300",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
    }
  })]), _c('p', {
    staticClass: "text-lg font-medium text-gray-700"
  }, [_vm._v(_vm._s(_vm.$t('voucher.emptyStateTitle')))]), _c('p', {
    staticClass: "text-sm text-gray-500 mt-2"
  }, [_vm._v(_vm._s(_vm.$t('voucher.emptyStateSubtitle')))])]) : _c('div', {
    staticClass: "overflow-x-auto"
  }, [_c('table', {
    staticClass: "min-w-full bg-white border border-gray-200"
  }, [_c('thead', {
    staticClass: "bg-gray-50"
  }, [_c('tr', [_c('th', {
    staticClass: "px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider border-b"
  }, [_vm._v(" " + _vm._s(_vm.$t('voucher.table.courier')) + " ")]), _c('th', {
    staticClass: "px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider border-b"
  }, [_vm._v(" " + _vm._s(_vm.$t('voucher.table.voucherName')) + " ")]), _c('th', {
    staticClass: "px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider border-b"
  }, [_vm._v(" " + _vm._s(_vm.$t('voucher.table.voucherCode')) + " ")]), _c('th', {
    staticClass: "px-6 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider border-b"
  }, [_vm._v(" " + _vm._s(_vm.$t('voucher.table.discount')) + " ")]), _c('th', {
    staticClass: "px-6 py-3 text-right text-xs font-medium text-gray-700 uppercase tracking-wider border-b"
  }, [_vm._v(" " + _vm._s(_vm.$t('voucher.table.maxDiscount')) + " ")]), _c('th', {
    staticClass: "px-6 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider border-b"
  }, [_vm._v(" " + _vm._s(_vm.$t('voucher.table.quota')) + " ")]), _c('th', {
    staticClass: "px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider border-b"
  }, [_vm._v(" " + _vm._s(_vm.$t('voucher.table.period')) + " ")]), _c('th', {
    staticClass: "px-6 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider border-b"
  }, [_vm._v(" " + _vm._s(_vm.$t('voucher.table.action')) + " ")])])]), _c('tbody', {
    staticClass: "divide-y divide-gray-200"
  }, _vm._l(_vm.voucherList.items, function (voucher) {
    return _c('tr', {
      key: voucher.id,
      staticClass: "hover:bg-gray-50 transition-colors"
    }, [_c('td', {
      staticClass: "px-6 py-4 whitespace-nowrap"
    }, [_c('div', {
      staticClass: "flex items-center gap-3"
    }, [_c('div', {
      staticClass: "flex-shrink-0 w-10 h-10 bg-cyan-100 rounded flex items-center justify-center overflow-hidden"
    }, [voucher.delivery_service && voucher.delivery_service.logo ? _c('img', {
      staticClass: "w-full h-full object-contain",
      attrs: {
        "src": voucher.delivery_service.logo,
        "alt": voucher.delivery_service.name
      },
      on: {
        "error": function error($event) {
          $event.target.style.display = 'none';
        }
      }
    }) : _c('svg', {
      staticClass: "h-5 w-5 text-cyan-500",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "fill": "none",
        "viewBox": "0 0 24 24",
        "stroke": "currentColor",
        "stroke-width": "2"
      }
    }, [_c('path', {
      attrs: {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "d": "M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
      }
    })])]), _c('div', [voucher.delivery_service ? _c('p', {
      staticClass: "text-sm font-medium text-gray-900"
    }, [_vm._v(" " + _vm._s(voucher.delivery_service.name) + " ")]) : _c('p', {
      staticClass: "text-sm text-gray-500"
    }, [_vm._v(" " + _vm._s(_vm.$t('voucher.allCourier')) + " ")])])])]), _c('td', {
      staticClass: "px-6 py-4"
    }, [_c('p', {
      staticClass: "text-sm font-semibold text-gray-900"
    }, [_vm._v(_vm._s(voucher.name))])]), _c('td', {
      staticClass: "px-6 py-4 whitespace-nowrap"
    }, [_c('span', {
      staticClass: "inline-flex items-center px-3 py-1 rounded-md text-sm font-mono font-bold bg-gray-100 text-gray-900 border border-gray-300"
    }, [_vm._v(" " + _vm._s(voucher.voucher_code) + " ")])]), _c('td', {
      staticClass: "px-6 py-4 whitespace-nowrap text-center"
    }, [_c('span', {
      staticClass: "inline-flex items-center px-2.5 py-0.5 rounded-full text-sm font-semibold bg-green-100 text-green-800"
    }, [_vm._v(" " + _vm._s(voucher.discount_percentage) + "% ")])]), _c('td', {
      staticClass: "px-6 py-4 whitespace-nowrap text-right"
    }, [voucher.max_discount_amount ? _c('p', {
      staticClass: "text-sm font-medium text-gray-900"
    }, [_vm._v(" " + _vm._s(_vm.formatCurrency(voucher.max_discount_amount)) + " ")]) : _c('p', {
      staticClass: "text-sm text-gray-400"
    }, [_vm._v(" - ")])]), _c('td', {
      staticClass: "px-6 py-4 whitespace-nowrap text-center"
    }, [_c('div', {
      staticClass: "text-sm"
    }, [_c('span', {
      staticClass: "font-bold text-blue-600"
    }, [_vm._v(_vm._s(voucher.available_quota))]), _c('span', {
      staticClass: "text-gray-400"
    }, [_vm._v("/")]), _c('span', {
      staticClass: "text-gray-600"
    }, [_vm._v(_vm._s(voucher.quota))])]), _c('div', {
      staticClass: "w-full bg-gray-200 rounded-full h-1.5 mt-1"
    }, [_c('div', {
      staticClass: "bg-blue-600 h-1.5 rounded-full",
      style: {
        width: "".concat(voucher.available_quota / voucher.quota * 100, "%")
      }
    })])]), _c('td', {
      staticClass: "px-6 py-4"
    }, [_c('div', {
      staticClass: "text-sm text-gray-700"
    }, [_c('div', {
      staticClass: "flex items-center gap-1 mb-1"
    }, [_c('svg', {
      staticClass: "h-4 w-4 text-gray-400",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "fill": "none",
        "viewBox": "0 0 24 24",
        "stroke": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        "d": "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
      }
    })]), _c('span', {
      staticClass: "text-xs text-gray-500"
    }, [_vm._v(_vm._s(_vm.$t('voucher.periodStart')))]), _c('span', {
      staticClass: "text-xs"
    }, [_vm._v(_vm._s(_vm.formatDate(voucher.start_date)))])]), _c('div', {
      staticClass: "flex items-center gap-1"
    }, [_c('svg', {
      staticClass: "h-4 w-4 text-gray-400",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "fill": "none",
        "viewBox": "0 0 24 24",
        "stroke": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        "d": "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
      }
    })]), _c('span', {
      staticClass: "text-xs text-gray-500"
    }, [_vm._v(_vm._s(_vm.$t('voucher.periodEnd')))]), _c('span', {
      staticClass: "text-xs"
    }, [_vm._v(_vm._s(_vm.formatDate(voucher.end_date)))])])])]), _c('td', {
      staticClass: "px-6 py-4 whitespace-nowrap text-center"
    }, [_c('button', {
      staticClass: "inline-flex items-center gap-2 px-4 py-2 bg-primary-500 text-white text-sm font-medium rounded-lg hover:bg-primary-600 transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2",
      on: {
        "click": function click($event) {
          return _vm.goToOrderForm(voucher);
        }
      }
    }, [_c('svg', {
      staticClass: "h-4 w-4",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "fill": "none",
        "viewBox": "0 0 24 24",
        "stroke": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        "d": "M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
      }
    })]), _vm._v(" " + _vm._s(_vm.$t('voucher.orderButton')) + " ")])])]);
  }), 0)])]), _vm.voucherList.total_pages > 1 ? _c('div', {
    staticClass: "mt-8 flex justify-center items-center gap-2"
  }, [_c('button', {
    staticClass: "px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors",
    attrs: {
      "disabled": _vm.voucherList.page === 1
    },
    on: {
      "click": function click($event) {
        return _vm.goToPage(_vm.voucherList.page - 1);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('voucher.pagination.previous')) + " ")]), _c('div', {
    staticClass: "flex gap-2"
  }, [_vm._l(_vm.visiblePages, function (page, index) {
    return [page === '...' ? _c('span', {
      key: "ellipsis-".concat(index),
      staticClass: "px-4 py-2 text-gray-400"
    }, [_vm._v(" ... ")]) : _c('button', {
      key: page,
      class: ['px-4 py-2 border rounded-lg transition-colors', page === _vm.voucherList.page ? 'bg-primary-500 text-white border-primary-500' : 'border-gray-300 hover:bg-gray-50 text-gray-700'],
      on: {
        "click": function click($event) {
          return _vm.goToPage(page);
        }
      }
    }, [_vm._v(" " + _vm._s(page) + " ")])];
  })], 2), _c('button', {
    staticClass: "px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors",
    attrs: {
      "disabled": _vm.voucherList.page === _vm.voucherList.total_pages
    },
    on: {
      "click": function click($event) {
        return _vm.goToPage(_vm.voucherList.page + 1);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('voucher.pagination.next')) + " ")])]) : _vm._e(), _vm.voucherList.total_items > 0 ? _c('div', {
    staticClass: "mt-4 text-center text-sm text-gray-600"
  }, [_vm._v(" " + _vm._s(_vm.$t('voucher.pagination.showing')) + " " + _vm._s((_vm.voucherList.page - 1) * _vm.voucherList.limit + 1) + " " + _vm._s(_vm.$t('voucher.pagination.to')) + " " + _vm._s(Math.min(_vm.voucherList.page * _vm.voucherList.limit, _vm.voucherList.total_items)) + " " + _vm._s(_vm.$t('voucher.pagination.of')) + " " + _vm._s(_vm.voucherList.total_items) + " " + _vm._s(_vm.$t('voucher.pagination.vouchers')) + " ")]) : _vm._e()])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }